
import { LightningElement, api } from 'lwc';

export default class sldsModalSlot extends LightningElement {


    

    @api modalTitle;
    @api suppressFooter = false;
    @api borderRadius;
    @api modalId = 'modal';
    @api size;
    @api active;

    _overflow = 'auto';
    @api 
    set overflow(val) {
        this._overflow = val;
    }
    get overflow() {
        return this._overflow;
    }

    handleCancel() {
        this.dispatchEvent(new CustomEvent('closemodal', { detail: '' } ));
    }
    renderedCallback() {
        this._applyVars();
    }


    get modalContentCl() {
        if (this._overflow === 'visible') {
            return 'slds-modal__content oveflow-visible';
        } else {
            return 'slds-modal__content';
        }
    }

    // Call this function in renderedCallback  --> e.g. renderedCallback() {this.applyVars();}
    _stylesApplied = false;
    // Apply Styles to the host
    _applyVars() {
        if (this._stylesApplied) return;

        if (this.size) {
            const modalEle = this.template.querySelector('.slds-modal');
            if (modalEle) {
                modalEle.classList.add(`slds-modal_${this.size.toLowerCase()}`);
            }
        }
        
        if (this.borderRadius) {
            const headerEle = this.template.querySelector('.slds-modal__header');
            const bottomEle = this.template.querySelector(this.suppressFooter ? '.slds-modal__content' : '.slds-modal__footer');
            if (headerEle) {
                headerEle.style.borderTopLeftRadius = this.borderRadius;
                headerEle.style.borderTopRightRadius = this.borderRadius;
                bottomEle.style.borderBottomRightRadius = this.borderRadius;
                bottomEle.style.borderBottomLeftRadius = this.borderRadius;
            }

            this.style.setProperty('--modal-border-radius', this.borderRadius);
        }
    }

}